module.exports = __webpack_public_path__ + "img/roof-repair-exterior-maintenance-06-xlarge.7f0c28d8.jpg";